export default __webpack_public_path__ + "locales/az/CreateEditRoomDialog.json?hash=14c3f2b7a61f701408e6d6b0e1b19bfd";